<div (window:resize)="onResize($event)">
  <mat-toolbar color="primary" class="lm-toolbar">
    <div class="logo">
      <button
        mat-icon-button
        (click)="toggleSideMenu(snav)"
        type="button"
        [ngClass]="{ 'is-active': sideMenuDisplayed }">
        @if (sideMenuDisplayed) {
          <img class="header-icons" src="assets/icon/menu.svg" />
        }
        @if (!sideMenuDisplayed) {
          <img class="header-icons" src="assets/icon/direction-back.svg" />
        }
      </button>
      <a href="javascript:void(0)" (click)="navigateHome()">
        <span class="lm-app-name"><img src="./assets/logo-new.png" /></span>
      </a>

      @if (nodeDetailsDTO) {
        @if (nodeDetailsDTO) {
          <span [style.color]="environment.color">{{ environment.name }}</span>
        }
      }
    </div>

    <div class="settings">
      <div class="time">{{ time }} UTC</div>
      <span class="vertical-separator"></span>
      <app-find-user-details [newIcon]="true"></app-find-user-details>
      <span class="vertical-separator"></span>
      @if (permissionService.hasManagePermissions() | async) {
        <button class="header-button" mat-button matTooltip="Settings" data-id="goToSettings_btn" routerLink="/manage">
          <mat-icon>description</mat-icon>Manage
        </button>
      }
      <span class="vertical-separator"></span>
      <button class="header-button" mat-button matTooltip="Logout" (click)="logout()">
        <mat-icon>logout</mat-icon>Logout
      </button>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="lm-sidenav-container" autosize>
    <mat-sidenav
      [opened]="true"
      [hidden]="!shouldDisplayMenu"
      #snav
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="90">
      <app-tree-sidenav
        [nodeDetailsDTO]="nodeDetailsDTO"
        [version]="version"
        [menuGroupDef]="menuGroupDef"></app-tree-sidenav>
    </mat-sidenav>

    @if (nodeDetailsDTO) {
      <mat-sidenav-content class="lm-sidenav-content" style="padding: 0">
        <div style="padding: 0; min-height: 75vh">
          <router-outlet></router-outlet>
        </div>
        <div style="height: 50px"></div>
      </mat-sidenav-content>
    }
  </mat-sidenav-container>
</div>
